import * as React from 'react';

export interface EndProps {
  children?: React.ReactNode;
}

export default class End extends React.PureComponent<EndProps> {}
